module.exports = __webpack_public_path__ + "hotel.a08c6fcfad3c4ca42c2b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/src/fonts/hotel.svg
// module id = ../../../../../src/fonts/hotel.svg
// module chunks = styles